import { UserGeneratedContentUI } from "./UserGeneratedContentUI";
import { StandardProps } from "../componentMap";
import Script from "next/script";

const USER_CONTENT_CLIENT_ID = "web-pdp-scaffold-ui";

export function UserGeneratedContent({
  product,
  runtimeConfig,
  experiencesRawString,
}: Pick<StandardProps, "product" | "runtimeConfig" | "experiencesRawString">) {
  return (
    <>
      <Script
        src="/user-content-ui/static/js/jl-user-content.js?includeCoreAssets=false"
        type="text/javascript"
        defer
      />
      <UserGeneratedContentUI
        productId={product.aliases.pimProductId}
        productURL={product.canonicalURL}
        apiKey={runtimeConfig.userGeneratedContentApiKey}
        clientId={USER_CONTENT_CLIENT_ID}
        experiencesRawString={experiencesRawString}
        isBrandPromise={true}
      />
    </>
  );
}
